import React, { type FC } from 'react'
import { useRecoilValue } from 'recoil'

import { GRID_VARIANT_SMALL, Grid, GridCell } from 'mailup-web-components'

import InputCritType from 'Pages/RecipientsList/components/filters/InputCritType'

import ActionDeleteCriterion from 'Pages/RecipientsList/components/filters/ActionDeleteCriterion'
import InputDateFrom from 'Pages/RecipientsList/components/filters/dates/InputDateFrom'
import InputDateTo from 'Pages/RecipientsList/components/filters/dates/InputDateTo'
import InputDatesType from 'Pages/RecipientsList/components/filters/dates/InputDatesType'

import { criterionOptinDateState } from 'Pages/RecipientsList/recoil/state/filters'

interface CriterionPendingDateProps {
  index: number
}

const CriterionPendingDate: FC<CriterionPendingDateProps> = ({ index }) => {
  const { datesType } = useRecoilValue(criterionOptinDateState(index))

  return (
    <Grid variant={GRID_VARIANT_SMALL} cols={12}>
      <GridCell span={3}>
        <InputCritType index={index} />
      </GridCell>

      <GridCell span={2}>
        <InputDatesType index={index} />
      </GridCell>
      {(datesType === 'afterDate' || datesType === 'interval') && (
        <GridCell span={2}>
          <InputDateFrom index={index} />
        </GridCell>
      )}
      {(datesType === 'beforeDate' || datesType === 'interval') && (
        <GridCell span={2}>
          <InputDateTo index={index} />
        </GridCell>
      )}
      <GridCell span={1}>
        <ActionDeleteCriterion index={index} />
      </GridCell>
    </Grid>
  )
}

export default CriterionPendingDate
